import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { graphql, useQuery } from 'react-apollo';
import compose from 'lodash.flowright';
import qs from 'query-string';

import getAccountCardQuery from '../../../../services/cards/graphql/queries/getAccountCard';
import getPurchasedCustomPrintRecipientQuery from '../../../../services/cards/graphql/queries/getPurchasedCustomPrintRecipient';
import AccountCard from '../../../../services/cards/components/AccountCard';
import { replaceAccountCardTextVariables } from '../../../../services/cards/components/AccountCard/helpers';
import { CARD_ELEMENT_TEXT_VARIABLE } from '../../../../services/cards/constants';

const propTypes = {
  accountCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  cardSide: PropTypes.string,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

const AccountCardPrint = ({ accountCard, cardSide, location }) => {
  const { purchasedCustomPrintId } = qs.parse(location?.search ?? '');
  const {
    data: { purchasedCustomPrint } = {},
    loading,
    error,
  } = useQuery(getPurchasedCustomPrintRecipientQuery, {
    variables: { id: purchasedCustomPrintId },
    skip: !purchasedCustomPrintId,
    errorPolicy: 'all',
  });
  const recipientFirstName =
    purchasedCustomPrint?.roster_identity_linked_identity_address
      ?.roster_identity_linked_identity?.identity?.name ?? '';
  const printableAccountCard = useMemo(
    () =>
      purchasedCustomPrintId
        ? replaceAccountCardTextVariables(accountCard, {
            [CARD_ELEMENT_TEXT_VARIABLE.IDENTITY_FIRST_NAME]:
              recipientFirstName,
          })
        : accountCard,
    [accountCard, purchasedCustomPrintId, recipientFirstName],
  );

  if (!accountCard || loading || error) {
    return null;
  }

  return (
    <Fragment>
      <Helmet>
        <body className="body-account-card-print" />
      </Helmet>

      <AccountCard
        printable
        accountCard={printableAccountCard}
        defaultSide={cardSide}
        animatable={!!cardSide}
        onElementConfigurationChange={() => {}}
      />
    </Fragment>
  );
};

AccountCardPrint.propTypes = propTypes;

const withAccountCard = graphql(getAccountCardQuery, {
  options: ({ match }) => ({
    variables: {
      id: match?.params?.accountCardId,
    },
  }),
  props: ({ data: { accountCard } = {}, ownProps }) => {
    const { match } = ownProps;
    const cardSide = (match?.params?.side ?? '').toUpperCase();

    return {
      cardSide,
      accountCard,
    };
  },
});

export default compose(withRouter, withAccountCard)(AccountCardPrint);
